import { useMutation, useQuery } from '@apollo/client/react';
import { Box, Button, Center, Heading, HStack, Link, Spinner, Table, Text } from '@chakra-ui/react';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { gql } from '@src/lib/gql';
import { scoBackendUrl } from '@src/lib/startups-url';
import React, { useCallback } from 'react';
import { LuSquareArrowUpRight, LuPlus } from 'react-icons/lu';
export const BizplanAccountsBlock = (props: {}) => {
  const query = useQuery(gql`
    query {
      viewer {
        id
        currentUser {
          id
          linkedBizplanAccounts {
            id
            externalUserId
            email
            companies {
              externalId
              externalType
              name
              signedUrl
            }
            signedAppUrl
            signedCreateCompanyUrl
          }
        }
      }
    }
  `);
  const [createLinkedAccount, createLinkedAccountMutation] = useMutation(gql`
    mutation ($input: CreateLinkedAccountInput!) {
      createLinkedAccount(input: $input) {
        linkedAccount {
          id
        }
      }
    }
  `);
  const handleCreateAccount = useCallback(async () => {
    try {
      await createLinkedAccount({
        variables: {
          input: {
            app: 'bizplan'
          }
        }
      });
      await query.refetch();
    } catch (err) {
      alert('An error occurred.');
    }
  }, []);
  const accounts = query.data?.viewer?.currentUser?.linkedBizplanAccounts || [];
  return <Box bgColor={'colorPalette.container'} border={'1px solid {colors.colorPalette.border/50}'} borderRadius={'md'} padding={6} width={'full'}>
      <HStack align={'center'} justify={'space-between'}>
        <Box>
          <Heading>Bizplan.com</Heading>
          <Text>Modern business planning tools for startups.</Text>
        </Box>
        <Box>
          <PaywalledAction contentPermission={'canActivateBizplan'}>
            {accounts.length == 0 && <Button disabled={createLinkedAccountMutation.loading || query.loading} loading={createLinkedAccountMutation.loading || query.loading} onClick={ev => {
            ev.preventDefault();
            handleCreateAccount();
          }}>
                Redeem Your Free Account
              </Button>}
          </PaywalledAction>
        </Box>
      </HStack>
      <PaywalledAction contentPermission={'canActivateBizplan'} variant={'blank'}>
        <>
          {query.loading && <Center padding={'1em'}>
              <Spinner />
            </Center>}

          {accounts.length > 0 && <Box paddingTop={'1em'}>
              {accounts.map(account => <Box key={account.id} paddingTop={'0.5em'}>
                  <Table.Root>
                    <Table.Header>
                      <Table.Row>
                        <Table.ColumnHeader colSpan={2}>
                          {'Bizplan Account: '}
                          {account.email}
                        </Table.ColumnHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {account.companies.length === 0 && <Table.Row>
                          <Table.Cell colSpan={2} textAlign={'center'}>
                            You don't have any plans yet.
                          </Table.Cell>
                        </Table.Row>}
                      {account.companies.map((company, idx) => <Table.Row key={idx}>
                          <Table.Cell width={'full'}>
                            {'Business Plan: '}
                            <strong>{company.name || `Untitled ${idx}`}</strong>
                          </Table.Cell>
                          <Table.Cell>
                            <Button asChild size={'sm'}>
                              <Link href={scoBackendUrl(company.signedUrl)} target={'_blank'}>
                                Edit in Bizplan
                                <LuSquareArrowUpRight />
                              </Link>
                            </Button>
                          </Table.Cell>
                        </Table.Row>)}
                      <Table.Row>
                        <Table.Cell colSpan={2} padding={'1.5em'} textAlign={'center'}>
                          <Button asChild size={'sm'} variant={'outline'}>
                            <Link href={scoBackendUrl(account.signedCreateCompanyUrl)} target={'_blank'}>
                              <LuPlus />
                              Create a New Plan in Bizplan
                              <LuSquareArrowUpRight />
                            </Link>
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table.Root>
                </Box>)}
            </Box>}
        </>
      </PaywalledAction>
    </Box>;
};